"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../context");
const videoStyles_1 = require("../../styling/videoStyles");
const styles_1 = require("./styles");
const VideoWrapper = (0, react_1.forwardRef)(({ onClick, variant, children, isFullScreen, classes, style, pillarBox = false, elementBlur = false, blurPixels = 11, mirror, }, ref) => {
    /**
     * These are needed to access the videoElement from the player/encoder UiContext.
     */
    const playerCtx = (0, react_1.useContext)(context_1.PlayerUiContext);
    const encoderCtx = (0, react_1.useContext)(context_1.EncoderUiContext);
    const ctx = playerCtx !== null && playerCtx !== void 0 ? playerCtx : encoderCtx;
    /**
     * Determines the styling needed based on pillarBox/isFullScreen props.
     */
    const styling = (0, styles_1.videoWrapperStyles)({
        pillarBox,
        fullScreen: isFullScreen,
        mirror,
        elementBlur,
        blurPixels,
    });
    const mergedClasses = (0, videoStyles_1.useStyles)({ source: classes !== null && classes !== void 0 ? classes : {}, target: styling }, "videoWrapper");
    const handleMouseOver = () => {
        if (ctx != null) {
            ctx.videoMouseOver = true;
        }
    };
    const handleMouseOut = () => {
        if (ctx != null) {
            ctx.videoMouseOver = false;
        }
    };
    return (react_1.default.createElement("div", { onMouseEnter: () => handleMouseOver(), onMouseLeave: () => handleMouseOut(), className: `
      ${mergedClasses.root ? mergedClasses.root : ""}
      ${variant != null ? `video-${variant} lv-${variant}` : ""}
    `, "data-selenium": "video-element", onClick: onClick, onKeyDown: undefined, style: style, role: "button", tabIndex: 0, ref: ref }, children));
});
VideoWrapper.displayName = "VideoWrapper";
exports.default = VideoWrapper;
//# sourceMappingURL=index.js.map